import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <div className="btncontainer">
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub className="picons"/>
            {" GitHub"}
          </Button>
          <Button variant="primary" href={props.demoLink} target="_blank">
            <CgWebsite className="picons"/>
            {" Website"}
          </Button>
        </div>

      </Card.Body>
    </Card>
  );
}
export default ProjectCards;